module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00026-fs8.9c27dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00026-fs8.png
// module id = 179
// module chunks = 0